export const departmentKey = 'DepartmentOwner';
